@if (showErrors) {
<span class="has-error">
  @for (e of errorMessages; track e) {
  <span [ngClass]="'help-' + (inline ? 'inline' : 'block')">
    {{ e.message | translate : e.data }}
  </span>
  }
</span>
}
